export default __webpack_public_path__ + "static/media/closet5-after1-480w.0cd2a94f.avif";